import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {hideLoadingAction} from '@Components/loading-toast';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import styles from './snackbar.module.scss';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {CircularProgress} from '@Components/circular-progress/circular-progress';

interface SnackbarProps {
  translateXValue?: number;
  zIndex?: number;
}

const DEFAULT_Z_INDEX = 20;

export function Snackbar({zIndex = DEFAULT_Z_INDEX, ...props}: SnackbarProps): ReactElement<any> | null {
  const currentLoading = useAppSelector((state) => {
    return state.loadingToast.currentLoading;
  });

  const hasProgress = currentLoading.progress !== undefined && currentLoading.progress !== null;
  const dispatch = useAppDispatch();
  const [closeEnded, setCloseEnded] = useState(false);

  useEffect((): void => {
    setTimeout((): void => {
      if (!currentLoading.show) {
        setCloseEnded(true);
      } else {
        setCloseEnded(false);
      }
    }, 500);
  }, [currentLoading.show]);

  const getLoader = (): ReactElement<any> | null => {
    if (currentLoading.show || !closeEnded) {
      if (hasProgress) {
        return <CircularProgress value={Number(currentLoading.progress) * 100} />;
      }
      return <CircularProgressLoader size={LOADER_SIZE.XSMALL} color={LOADER_COLOR.WHITE} classes="spacing-m-0" />;
    }

    return null;
  };

  const getText = (): string => {
    return currentLoading.text;
  };

  const getCloseIcon = (): ReactElement<any> | null => {
    if (!currentLoading.hideIcon) {
      return (
        <Icon
          icon="icon-close"
          className="content-body-white spacing-m-l-4"
          size={IconSize.SIZE_ICON_16}
          onClick={(): void => {
            dispatch(hideLoadingAction(currentLoading.key));
          }}
        />
      );
    }

    return null;
  };

  return (
    <div
      style={{
        transform: props.translateXValue !== undefined ? `translateX(calc(-50% + ${props.translateXValue}px))` : 'translateX(-50%)',
        zIndex: zIndex,
      }}
      className={`${styles.snackbar} flexbox flex-items-center ${currentLoading.show ? styles.in : styles.out} flex-h-row radius-round ${
        !currentLoading.show && closeEnded ? styles.outEnded : ''
      }`}
    >
      {getLoader()}
      <Text val={getText()} className={`content-body-white ${currentLoading.show || !closeEnded ? 'spacing-m-l-2' : ''}`} size={TextSize.XXSMALL} />
      {getCloseIcon()}
    </div>
  );
}
